import { createApp } from 'vue'
import ImageFader from '~/js/components/imageFader'

const CLASS_NAME_TEIKIBIN_MAINVIEW = 'js-teikibin-mainview'

document.addEventListener('DOMContentLoaded', () => {
  const elementsTeikibinMainview = document.getElementsByClassName(
    CLASS_NAME_TEIKIBIN_MAINVIEW
  )
  if (!elementsTeikibinMainview.length) return

  Array.from(elementsTeikibinMainview).forEach((element) => {
    const elementsTeikibinMainviewItem = element.getElementsByClassName(
      'js-teikibin-mainview-item'
    )
    const items = Array.from(elementsTeikibinMainviewItem).map((item) => {
      const { src, alt } = item.dataset
      return { src, alt }
    })
    createApp({
      name: 'SectionsTeikibinMainview',
      components: {
        ImageFader,
      },
      data() {
        return {
          items,
        }
      },
      methods: {
        dispatchFaderImageClicked(index) {
          window.dispatchEvent(
            new CustomEvent('fader-image-clicked', { detail: { index } })
          )
        },
      },
    }).mount(element)
  })
})
